<template>
  <div
    ref="masonryElement"
    class="__grid--masonry"
    :class="{ '__stretch-first': stretchFirst }"
    :style="{ '--grid-gap': gridGap, '--col-width': colWidth }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    stretchFirst: {
      type: Boolean,
      default: () => false,
    },
    gridGap: {
      type: String,
      default: () => '0.5em',
    },
    colWidth: {
      type: String,
      default: () => 'minmax(Min(20em, 100%), 1fr)',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    window.addEventListener('resize', this.refreshLayout);

    this.calcGrid([this.$refs.masonryElement]);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.refreshLayout);
  },
  data() {
    return {
      grids: [],
    };
  },
  watch: {
    items: {
      handler() {
        this.calcGrid([this.$refs.masonryElement]);
      },
    },
  },
  methods: {
    refreshLayout() {
      this.grids.forEach(grid => {
        /* get the post relayout number of columns */
        const ncol = getComputedStyle(grid._el).gridTemplateColumns.split(' ').length;

        grid.items.forEach(c => {
          const new_h = c.getBoundingClientRect().height;

          if (new_h !== +c.dataset.h) {
            c.dataset.h = new_h;
            grid.mod++;
          }
        });

        /* if the number of columns has changed */
        if (grid.ncol !== ncol || grid.mod) {
          /* update number of columns */
          grid.ncol = ncol;
          /* revert to initial positioning, no margin */
          grid.items.forEach(c => c.style.removeProperty('margin-top'));
          /* if we have more than one column */
          if (grid.ncol > 1) {
            grid.items.slice(ncol).forEach((c, i) => {
              const prev_fin = grid.items[i].getBoundingClientRect().bottom; /* bottom edge of item above */
              const curr_ini = c.getBoundingClientRect().top; /* top edge of current item */

              c.style.marginTop = `${prev_fin + grid.gap - curr_ini}px`;
            });
          }

          grid.mod = 0;
        }
      });
    },
    async calcGrid(_masonryArr) {
      await this.$nextTick();

      if (_masonryArr.length && getComputedStyle(_masonryArr[0]).gridTemplateRows !== 'masonry') {
        this.grids = _masonryArr.map(grid => {
          return {
            _el: grid,
            gap: parseFloat(getComputedStyle(grid).gridRowGap),
            items: [...grid.childNodes].filter(c => c.nodeType === 1 && +getComputedStyle(c).gridColumnEnd !== -1),
            ncol: 0,
            mod: 0,
          };
        });

        this.refreshLayout();
      }
    },
  },
};
</script>

<style>
  :global(.__grid--masonry) {
    display: grid;
    grid-template-columns: repeat(auto-fit, var(--col-width));
    grid-template-rows: masonry;
    grid-gap: var(--grid-gap);
  }
  :global(.__grid--masonry > *) {
    align-self: start
  }
  :global(.__grid--masonry.__stretch-first > *:first-child) {
    grid-column: 1/ -1;
  }
</style>
